/**
 * Чисті tz-хелпери для журналу (099, day-arithmetic only).
 * Усі tz-проєкції — через Intl.DateTimeFormat, ніколи ручним offset.
 * Без IO — unit-тестабельні.
 */

// --- Внутрішні утиліти ---

function dateParts(
  date: Date,
  tz: string,
): { year: number; month: number; day: number; hour: number; minute: number } {
  const fmt = new Intl.DateTimeFormat("en-CA", {
    timeZone: tz,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });
  const parts = Object.fromEntries(fmt.formatToParts(date).map((p) => [p.type, p.value]));
  return {
    year: Number(parts.year),
    month: Number(parts.month),
    day: Number(parts.day),
    hour: Number(parts.hour) % 24,
    minute: Number(parts.minute),
  };
}

function formatDate(year: number, month: number, day: number): string {
  return [
    String(year).padStart(4, "0"),
    String(month).padStart(2, "0"),
    String(day).padStart(2, "0"),
  ].join("-");
}

function parseDate(date: string): Date {
  return new Date(`${date}T00:00:00Z`);
}

// --- Публічний API ---

/**
 * Цивільна дата (YYYY-MM-DD) у заданій tz.
 */
export function civilDate(now: Date, tz: string): string {
  const { year, month, day } = dateParts(now, tz);
  return formatDate(year, month, day);
}

/**
 * Попередній день відносно date (YYYY-MM-DD) у tz.
 */
export function prevDay(date: string, tz: string): string {
  const ms = parseDate(date).getTime() - 24 * 60 * 60 * 1000;
  return civilDate(new Date(ms), tz);
}

/** Наступний день відносно date (YYYY-MM-DD) у tz. */
export function nextDay(date: string, tz: string): string {
  const ms = parseDate(date).getTime() + 24 * 60 * 60 * 1000;
  return civilDate(new Date(ms), tz);
}

/** Чи є date (YYYY-MM-DD) сьогоднішнім днем у tz? */
export function isToday(date: string, tz: string): boolean {
  return date === civilDate(new Date(), tz);
}
